import React, { useState, useEffect } from 'react';

import Sidebar from '../../components/base/Sidebar/Sidebar';
import './disciplinas.css';

import AddLinkIcon from '@mui/icons-material/AddLink';
import LaunchIcon from '@mui/icons-material/Launch';
import CheckIcon from '@mui/icons-material/Check';
import WarningIcon from '@mui/icons-material/Warning';
import CloseIcon from '@mui/icons-material/Close';
import RunningWithErrorsOutlinedIcon from '@mui/icons-material/RunningWithErrorsOutlined';

import Card from '../../components/base/Card/Card';
import { useNavigate } from 'react-router-dom';

function Disciplinas() {
  const [selectedDisciplina, setSelectedDisciplina] = useState(null);
  const [selectedRelatorio, setSelectedRelatorio] = useState(null);
  const [respostas, setRespostas] = useState({});
  const [message, setMessage] = useState(""); // Mensagem para feedback ao usuário

  const subsecaoMap = {
    rvsando_obj: 6,
    rvsando_dis: 7,
    rvendo_obj: 8,
    rvendo_dis: 9
};

  const navigate = useNavigate();

  const disciplinas = [
    { nome: 'Biologia', grupo: 'bio', turma: 'A', horario: 'seg. e qua. 17h às 20h', aulasTotais: 70, aulasFeitas: 35, relatorios: 33 },
    { nome: 'Química', grupo: 'quimica', turma: 'G', horario: 'ter. e sex. 17h às 19h', aulasTotais: 72, aulasFeitas: 42, relatorios: 35 },
    { nome: 'Física', grupo: 'fisica', turma: 'C', horario: 'seg. e sex. 15h às 18h', aulasTotais: 65, aulasFeitas: 30, relatorios: 25 },
    { nome: 'Matemática', grupo: 'functions', turma: 'B', horario: 'ter. e qui. 18h às 21h', aulasTotais: 75, aulasFeitas: 40, relatorios: 38 },
    { nome: 'Redação', grupo: 'create', turma: 'H', horario: 'qua. e sex. 10h às 12h', aulasTotais: 50, aulasFeitas: 22, relatorios: 15 },
    { nome: 'Português', grupo: 'chat', turma: 'D', horario: 'qua. e sex. 14h às 17h', aulasTotais: 60, aulasFeitas: 28, relatorios: 20 },
    { nome: 'História', grupo: 'historia', turma: 'E', horario: 'ter. e qui. 16h às 19h', aulasTotais: 80, aulasFeitas: 50, relatorios: 45 },
    { nome: 'Geografia', grupo: 'geografia', turma: 'F', horario: 'seg. e qui. 13h às 16h', aulasTotais: 68, aulasFeitas: 33, relatorios: 28 },
  ];

  const [questoes, setQuestoes] = useState({
    rvendo_obj: Array(0).fill({ tipo: 'objetiva' }),
    rvendo_dis: Array(0).fill({ tipo: 'discursiva' }),
    rvsando_obj: Array(0).fill({ tipo: 'objetiva' }),
    rvsando_dis: Array(0).fill({ tipo: 'discursiva' }),
});

const ordemQuestoes = ["rvsando_obj", "rvsando_dis", "rvendo_obj", "rvendo_dis"];

// Criar um array com todas as questões em ordem
const questoesOrdenadas = ordemQuestoes.flatMap(secao => 
    questoes[secao]?.map(q => ({ ...q, secao })) || []
);

const titulosSecoes = {
  rvsando_obj: "RVsando Objetivas",
  rvsando_dis: "RVsando Discursivas",
  rvendo_obj: "RVendo Objetivas",
  rvendo_dis: "RVendo Discursivas"
};

const [aulas, setAulas] = useState([]);

const userID = localStorage.getItem('userID');

const [disciplinasAtivas, setDisciplinasAtivas] = useState([]);

useEffect(() => {
  localStorage.removeItem("tituloAula"); // Remove ao entrar na página de disciplinas
}, []);

useEffect(() => {
  const fetchDisciplinasAtivas = async () => {
    try {
      const response = await fetch(`https://rvensino.com.br/get.php?action=get_disciplinas_by_aluno&ID_aluno=${userID}`);
      const data = await response.json();
        
      if (data && Array.isArray(data)) {
        setDisciplinasAtivas(data.map(d => ({ nome: d.disciplina, turma: d.turma })));
      } else {
        console.warn("Formato inesperado da resposta da API.", data);
        setDisciplinasAtivas([]);
      }
    } catch (error) {
      console.error("Erro ao buscar disciplinas ativas:", error);
      setDisciplinasAtivas([]);
    }
  };
  
  if (userID) {
    fetchDisciplinasAtivas();
  }
}, [userID]);

const handleRespostaChange = (num_questao, secao, campo, valor) => {
  setRespostas(prev => ({
      ...prev,
      [num_questao]: {
          ...prev[num_questao],
          secao, 
          [campo]: valor 
      }
}));
};

const [isSubmitting, setIsSubmitting] = useState(false);

const submitRelatorio = async () => {
  // Previne múltiplas submissões
  if (isSubmitting) return;
  
  const userID = localStorage.getItem('userID');
  const aulaID = selectedRelatorio?.id;

  if (!aulaID || !userID) {
    //setMessage("Erro ao enviar relatório: ID do usuário ou da aula não encontrado.");
    return;
  }

  // VALIDAÇÃO ETAPA 1: Verifica se cada sessão tem o número certo de questões
  const sectionCounts = {
    rvsando_obj: questoes.rvsando_obj.length,
    rvsando_dis: questoes.rvsando_dis.length,
    rvendo_obj: questoes.rvendo_obj.length,
    rvendo_dis: questoes.rvendo_dis.length
  };
  
  // Conta respostas por sessão
  const responseCounts = {};
  for (const [numQuestao, resposta] of Object.entries(respostas)) {
    if (!resposta || !resposta.secao) {
      const errorMsg = `Erro de validação: Questão ${numQuestao} não tem uma seção definida`;

      const userMsgData = {
        errorMsg: errorMsg,
        userID: userID,
        aulaID: aulaID,
        timestamp: new Date().toISOString(),
        respostas: respostas
      }
      
      fetch(`https://rvensino.com.br/get.php?action=error_log&error_log=${encodeURIComponent(JSON.stringify(userMsgData))}`);
      //setMessage("[ERRO INTERNO] Seu relatório não pôde ser enviado, por favor entre em contato com o suporte.");
      // return;
    }
    
    responseCounts[resposta.secao] = (responseCounts[resposta.secao] || 0) + 1;
  }
  
  // Compara contagem de questões da sessão
  for (const section of Object.keys(sectionCounts)) {
    const expected = sectionCounts[section];
    const actual = responseCounts[section] || 0;
    
    if (expected !== actual) {
      const errorMsg = `Erro de validação: Número incorreto de questões na seção "${titulosSecoes[section]}" (Esperado: ${expected}, Atual: ${actual})`;

      const userMsgData = {
        errorMsg: errorMsg,
        userID: userID,
        aulaID: aulaID,
        timestamp: new Date().toISOString(),
        respostas: respostas
      }
      
      fetch(`https://rvensino.com.br/get.php?action=error_log&error_log=${encodeURIComponent(JSON.stringify(userMsgData))}`);
      //setMessage("[ERRO INTERNO] Seu relatório não pôde ser enviado, por favor entre em contato com o suporte.");
      // return;
    }
  }
  
  // VALIDAÇÃO ETAPA 2: Verifica se todas as questões estão presentes e na ordem correta
  const expectedQuestionCount = questoesOrdenadas.length;
  const actualResponseCount = Object.keys(respostas).length;
  
  if (expectedQuestionCount !== actualResponseCount) {
    const errorMsg = `Erro de validação: Número total de questões não corresponde (Esperado: ${expectedQuestionCount}, Atual: ${actualResponseCount})`;

    const userMsgData = {
      errorMsg: errorMsg,
      userID: userID,
      aulaID: aulaID,
      timestamp: new Date().toISOString(),
      respostas: respostas
    }
    
    fetch(`https://rvensino.com.br/get.php?action=error_log&error_log=${encodeURIComponent(JSON.stringify(userMsgData))}`);
    //setMessage("[ERRO INTERNO] Seu relatório não pôde ser enviado, por favor entre em contato com o suporte.");
    // return;
  }
  
  // VALIDAÇÃO ETAPA 3: verifica os detalhes da questão
  for (let i = 1; i <= expectedQuestionCount; i++) {
    const resposta = respostas[i];
    const questao = questoesOrdenadas[i-1];
    
    // Checa se questão existe
    if (!resposta) {
      const errorMsg = `Erro de validação: Resposta faltante para a questão ${i}`;

      const userMsgData = {
        errorMsg: errorMsg,
        userID: userID,
        aulaID: aulaID,
        timestamp: new Date().toISOString(),
        respostas: respostas
      }
      
      fetch(`https://rvensino.com.br/get.php?action=error_log&error_log=${encodeURIComponent(JSON.stringify(userMsgData))}`);
      //setMessage("[ERRO INTERNO] Seu relatório não pôde ser enviado, por favor entre em contato com o suporte.");
      // return;
    }
    
    // Check se tem match da seção
    if (resposta.secao !== questao.secao) {
      const errorMsg = `Erro de validação: Seção incorreta para questão ${i} (Esperado: ${questao.secao}, Atual: ${resposta.secao})`;

      const userMsgData = {
        errorMsg: errorMsg,
        userID: userID,
        aulaID: aulaID,
        timestamp: new Date().toISOString(),
        respostas: respostas
      }
      
      fetch(`https://rvensino.com.br/get.php?action=error_log&error_log=${encodeURIComponent(JSON.stringify(userMsgData))}`);
      //setMessage("[ERRO INTERNO] Seu relatório não pôde ser enviado, por favor entre em contato com o suporte.");
      // return;
    }
    
    // Check se subsecao_id é válido
    if (!subsecaoMap[resposta.secao]) {
      const errorMsg = `Erro de validação: Subseção inválida para questão ${i}: ${resposta.secao}`;

      const userMsgData = {
        errorMsg: errorMsg,
        userID: userID,
        aulaID: aulaID,
        timestamp: new Date().toISOString(),
        respostas: respostas
      }
      
      fetch(`https://rvensino.com.br/get.php?action=error_log&error_log=${encodeURIComponent(JSON.stringify(userMsgData))}`);
      //setMessage("[ERRO INTERNO] Seu relatório não pôde ser enviado, por favor entre em contato com o suporte.");
      // return;
    }
    
    // Para questões eletivas, checa se a resposta é válida
    if (questao.tipo === 'objetiva' && questao.secao.includes('obj')) {
      if (!resposta.resposta) {
        const errorMsg = `Erro de validação: Alternativa não selecionada para questão objetiva ${i}`;

        const userMsgData = {
          errorMsg: errorMsg,
          userID: userID,
          aulaID: aulaID,
          timestamp: new Date().toISOString(),
          respostas: respostas
        }
        
        fetch(`https://rvensino.com.br/get.php?action=error_log&error_log=${encodeURIComponent(JSON.stringify(userMsgData))}`);
        //setMessage("[ERRO INTERNO] Seu relatório não pôde ser enviado, por favor entre em contato com o suporte.");
        // return;
      }
      
      const validOptions = ['A', 'B', 'C', 'D', 'E'];
      if (!validOptions.includes(resposta.resposta)) {
        const errorMsg = `Erro de validação: Alternativa inválida para questão ${i}: ${resposta.resposta}`;

        const userMsgData = {
          errorMsg: errorMsg,
          userID: userID,
          aulaID: aulaID,
          timestamp: new Date().toISOString(),
          respostas: respostas
        }
        
        fetch(`https://rvensino.com.br/get.php?action=error_log&error_log=${encodeURIComponent(JSON.stringify(userMsgData))}`);
        //setMessage("[ERRO INTERNO] Seu relatório não pôde ser enviado, por favor entre em contato com o suporte.");
        // return;
      }
    }
    
    // VCheca outros campos necessários
    if (resposta.acerto === undefined) {
      const errorMsg = `Erro de validação: Campo "acerto" não preenchido para questão ${i}`;

      const userMsgData = {
        errorMsg: errorMsg,
        userID: userID,
        aulaID: aulaID,
        timestamp: new Date().toISOString(),
        respostas: respostas
      }
      
      fetch(`https://rvensino.com.br/get.php?action=error_log&error_log=${encodeURIComponent(JSON.stringify(userMsgData))}`);
      //setMessage("[ERRO INTERNO] Seu relatório não pôde ser enviado, por favor entre em contato com o suporte.");
      // return;
    }
    
    if (resposta.dificuldade === undefined) {
      const errorMsg = `Erro de validação: Campo "dificuldade" não preenchido para questão ${i}`;

      const userMsgData = {
        errorMsg: errorMsg,
        userID: userID,
        aulaID: aulaID,
        timestamp: new Date().toISOString(),
        respostas: respostas
      }
      
      fetch(`https://rvensino.com.br/get.php?action=error_log&error_log=${encodeURIComponent(JSON.stringify(userMsgData))}`);
      //setMessage("[ERRO INTERNO] Seu relatório não pôde ser enviado, por favor entre em contato com o suporte.");
      // return;
    }
    
    if (resposta.duvida === undefined) {
      const errorMsg = `Erro de validação: Campo "duvida" não preenchido para questão ${i}`;

      const userMsgData = {
        errorMsg: errorMsg,
        userID: userID,
        aulaID: aulaID,
        timestamp: new Date().toISOString(),
        respostas: respostas
      }
      
      fetch(`https://rvensino.com.br/get.php?action=error_log&error_log=${encodeURIComponent(JSON.stringify(userMsgData))}`);
      //setMessage("[ERRO INTERNO] Seu relatório não pôde ser enviado, por favor entre em contato com o suporte.");
      // return;
    }
  }

  // Verifica se todas as respostas estão preenchidas
  const isRespostaPreenchida = (resposta, tipo) => {
    if (tipo === 'objetiva') {
      return (
        resposta?.resposta && 
        resposta?.acerto !== undefined && 
        resposta?.dificuldade !== undefined && 
        resposta?.duvida !== undefined 
      );
    } else if (tipo === 'discursiva') {
      return (
        resposta?.acerto !== undefined && 
        resposta?.dificuldade !== undefined && 
        resposta?.duvida !== undefined 
      );
    }
    return false;
  };

  const todasRespostasPreenchidas = questoesOrdenadas.every((questao, index) => {
    const numQuestao = index + 1;
    const resposta = respostas[numQuestao];
    return isRespostaPreenchida(resposta, questao.tipo);
  });

  if (!todasRespostasPreenchidas) {
    setMessage("Por favor, preencha todas as respostas antes de submeter o relatório.");
    return;
  }
  
  try {
    setIsSubmitting(true);
    setMessage("Enviando relatório...");
    
    // checa se relatório já foi submetido
    const checkSubmission = await fetch(`https://rvensino.com.br/get.php?action=check_relatorio_status&aula_id=${aulaID}&user_id=${userID}`);
    const submissionStatus = await checkSubmission.json();
    
    if (submissionStatus && submissionStatus.delivered === "1") {
      setMessage("Este relatório já foi entregue anteriormente.");
      setIsSubmitting(false);
      return;
    }
    
    // Novo envio em formato JSON único
    const respostasFormatadas = Object.entries(respostas).map(([num_questao, resposta]) => {
      const secao = resposta?.secao || "";
      const subsecao_id = subsecaoMap[secao] ?? 1;
      return {
        num_questao,
        subsecao_id,
        resposta: resposta?.resposta ?? '',
        acerto: resposta?.acerto ?? '0',
        dificuldade: resposta?.dificuldade ?? '1',
        duvida: resposta?.duvida ?? '0'
      };
    });

    const jsonData = {
      aula_id: aulaID,
      user_id: userID,
      respostas: respostasFormatadas
    };

    await fetch(`https://rvensino.com.br/get.php?action=add_relatorio&data=${encodeURIComponent(JSON.stringify(jsonData))}`);

    // if (!response.ok) {
    //   throw new Error('Erro ao enviar relatório');
    // }

    console.log(jsonData)
    
    // Registra o relatório como enviado
    await fetch(`https://rvensino.com.br/get.php?action=register_relatorio&user_id=${userID}&aula_id=${aulaID}`);
    
    // depois de todos os requests serem enviados com sucesso, define mensagem de sucesso
    setMessage("Relatório enviado com sucesso! ✅");

    // marca relatório como enviado pra evitar resubmissão
    await fetch(`https://rvensino.com.br/get.php?action=mark_relatorio_delivered&aula_id=${aulaID}&user_id=${userID}`);

    setTimeout(() => {
      closePopup();
    }, 1000);
  } catch (error) {
    const errorMsg = `Erro ao enviar relatório: ${error.message}`;
    
    const userMsgData = {
      errorMsg: errorMsg,
      userID: userID,
      aulaID: aulaID,
      timestamp: new Date().toISOString(),
      respostas: respostas
    }
    
    fetch(`https://rvensino.com.br/get.php?action=error_log&error_log=${encodeURIComponent(JSON.stringify(userMsgData))}`);
    setMessage("[ERRO INTERNO] Seu relatório não pôde ser enviado, por favor entre em contato com o suporte.");
  } finally {
    setIsSubmitting(false);
  }
};

const openPopup = async (disciplina) => {
  setSelectedDisciplina(disciplina);
  setSelectedRelatorio(null);

  try {
    const response = await fetch(`https://rvensino.com.br/get.php?action=get_aulas_by_turma_and_aluno&turma=${encodeURIComponent(disciplina.turma)}&aluno=${userID}`);
    setMessage("");

    // Verifica se a resposta é bem-sucedida
    if (!response.ok) {
        throw new Error(`Erro na requisição: ${response.status} ${response.statusText}`);
    }

    // Verifica se o corpo da resposta não está vazio
    const responseText = await response.text();
    if (!responseText) {
        throw new Error('Resposta vazia recebida do servidor.');
    }

    // Tenta converter o texto da resposta para JSON
    let data;
    try {
        data = JSON.parse(responseText);
    } catch (jsonError) {
        throw new Error('Erro ao converter resposta para JSON: ' + jsonError.message);
    }

    setAulas(data);
  } catch (error) {
      console.error("Erro ao buscar aulas:", error);
      // Aqui você pode definir uma mensagem de erro para exibir no UI, se desejar
      setAulas([]); // Define aulas como um array vazio em caso de erro
  }
};

// EXIBIÇÃO DO RELATÓRIO

const openRelatorioPopup = async (aula) => {
  setSelectedRelatorio(aula);

  const tituloAula = `${aula.nome}`;
  localStorage.setItem("tituloAula", tituloAula);

  try {
      const response = await fetch(`https://rvensino.com.br/get.php?action=get_report_format&aula_id=${aula.id}`);
      // const response = await fetch(`https://rvensino.com.br/get.php?action=get_report_format&aula_id=728`);
      const data = await response.json();
      console.log('report format: ')
      console.log(data)

      if (data && Array.isArray(data) && data.length > 0) {
          const relatorio = data[0];

          
          const questoesAtualizadas = {
              rvendo_obj: Array(parseInt(relatorio.quest_rvendo_obj || "0")).fill({ tipo: 'objetiva' }),
              rvendo_dis: Array(parseInt(relatorio.quest_rvendo_dis || "0")).fill({ tipo: 'discursiva' }),
              rvsando_obj: Array(parseInt(relatorio.quest_rvsando_obj || "0")).fill({ tipo: 'objetiva' }),
              rvsando_dis: Array(parseInt(relatorio.quest_rvsando_dis || "0")).fill({ tipo: 'discursiva' }),
          };

          setQuestoes(questoesAtualizadas);
      } else {
          console.warn("Formato inesperado da resposta:", data);
          setQuestoes({
              rvendo_obj: [],
              rvendo_dis: [],
              rvsando_obj: [],
              rvsando_dis: [],
          });
      }
  } catch (error) {
      console.error("Erro ao buscar formato do relatório:", error);
      setQuestoes({
          rvendo_obj: [],
          rvendo_dis: [],
          rvsando_obj: [],
          rvsando_dis: [],
      });
  }
};

const closePopup = () => {
  localStorage.removeItem("tituloAula");
  setSelectedDisciplina(null);
  setSelectedRelatorio(null);
};

const saveRelatorio = async (e) => {
  setTimeout(() => {
    navigate('/disciplinas');
  }, 2000);
};

const formatDate = (dateString) => {
  if (!dateString || dateString === "0000-00-00") return "-";
  const [year, month, day] = dateString.split("-");
  return `${day}-${month}-${year}`;
};

return (
  <div className="page-container">
    <div className="menu">
      <Sidebar />
    </div>
    <div className='content'>
      <div className={`content-container ${selectedDisciplina || selectedRelatorio ? 'blur' : ''}`}>
      <div className='subjects-container'>
{disciplinas.map((disciplina, index) => {
  const disciplinaAtiva = disciplinasAtivas.find(d => d.nome === disciplina.nome);
  const isUnavailable = !disciplinaAtiva;

  return (
    <div key={index} onClick={!isUnavailable ? () => openPopup(disciplinaAtiva) : null}>
      <Card
        subject
        title=''
        info={disciplina.nome}
        icon={disciplina.grupo}
        unavailable={isUnavailable} // Passa a propriedade para o Card
      />
    </div>
  );
})}
</div>


      </div>
    </div>

    {/* Popup de detalhes da disciplina */}
    {selectedDisciplina && !selectedRelatorio && (
      <div className="popup-overlay-subject" onClick={closePopup}>
        <div className="popup-content-subject" onClick={(e) => e.stopPropagation()}>
          <h2 className="subject-title">{selectedDisciplina.nome}</h2>

          {/* <div className="subject-details">
            <p><strong>Turma:</strong> {selectedDisciplina.turma}</p>
            <p><strong>Horário:</strong> {selectedDisciplina.horario}</p>
            <p><strong>Aulas Totais:</strong> {selectedDisciplina.aulasTotais}</p>
            <p><strong>Relatórios Entregues:</strong> {selectedDisciplina.relatorios}</p>
          </div> */}

          <div className="subject-table">
            <table>

              <thead>
                <tr>
                    <th>Número</th>
                    <th>Nome</th>
                    <th>Data da Aula</th>
                    <th>Data de Entrega</th>
                    <th></th>
                    <th>Status</th>
                </tr>
              </thead>



              <tbody>
              
                {aulas.length > 0 ? (
                    aulas.map((aula, i) => (
                        <tr key={i}>
                            <td>{aula.numero}</td>
                            <td>{aula.nome}</td>
                            <td>{formatDate(aula.date)}</td>
                            <td>{aula.report_date === '0000-00-00' ? '-' : formatDate(aula.report_date)}</td>

                            <td>
                                <AddLinkIcon


style={{
  color: aula.report_date === '0000-00-00' || aula.entrega_disponivel == 0 || aula.report_late === true || aula.delivered === 1 ? '#aaa' : '#000',
  fontSize: 30,
  cursor: aula.report_date === '0000-00-00' || aula.entrega_disponivel == 0 || aula.report_late === true || aula.delivered === 1 ? 'not-allowed' : 'pointer',
}}
//onClick={aula.report_date === '0000-00-00' || aula.entrega_disponivel == 0 || aula.report_late === true || aula.delivered === 1 ? () => {} : () => openRelatorioPopup(aula)}
onClick={aula.report_date === '0000-00-00' || aula.entrega_disponivel == 0 || aula.report_late === true || aula.delivered === 1 ? 
  () => {} : 
  async () => {
    try {
      // Criptografa o ID do usuário
      const responseUser = await fetch(`https://rvensino.com.br/get.php?action=criptografar&data=${userID}`);
      const encryptedUserID = await responseUser.text();
      
      // Criptografa o ID da aula
      const responseAula = await fetch(`https://rvensino.com.br/get.php?action=criptografar&data=${aula.id}`);
      const encryptedAulaID = await responseAula.text();
      
      // Abre a página com os IDs criptografados
      window.open(`https://rvensino.com.br/relatorio.php?uid=${encryptedUserID}&aid=${encryptedAulaID}`, '_blank');
    } catch (error) {
      console.error('Erro ao criptografar dados:', error);
    }
  }
}




                                      // style={{ color: '#000', fontSize: 30, cursor: 'pointer' }}
                                      // onClick={() => openRelatorioPopup(aula)}




                                      // onClick={() =>
                                      //     openRelatorioPopup({
                                      //         disciplina: selectedDisciplina.nome,
                                      //         turma: selectedDisciplina.turma,
                                      //         relatorio: aula.nome,
                                      //         data: aula.date,
                                      //     })
                                      // }
                                    //   style={{
                                    //     color: '#aaa', // Cor mais clara para indicar desativado
                                    //     fontSize: 30,
                                    //     cursor: 'not-allowed', // Cursor indicando que não é clicável
                                    //     opacity: 0.5, // Tornar mais opaco para parecer desativado
                                    // }}
                                    // onClick={() => {}}
                                  />
                              </td>

                              <td>
                                  {aula.delivered === 1 ? (
                                    <CheckIcon style={{ color: 'green', fontSize: 24 }} />
                                  ) : aula.report_late ? (
                                    <CloseIcon style={{ color: 'red', fontSize: 24 }} />
                                  ) : aula.nearly_report_date ? (
                                    <RunningWithErrorsOutlinedIcon style={{ color: 'orange', fontSize: 24 }} />
                                  ) : null}
                                </td>


                        </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan="6">Nenhuma aula encontrada</td>
                    </tr>
                )}
            </tbody>





            </table>
          </div>

          <button className="close-popup-subject" onClick={closePopup}>X</button>
        </div>
      </div>
    )}

    {/* Popup de relatório */}
    {selectedRelatorio && (
      <div className="popup-overlay-subject relatorio" onClick={closePopup}>
        <div className="popup-content-subject" onClick={(e) => e.stopPropagation()}>
        <h2 className="subject-title relatorio">
              {localStorage.getItem("tituloAula") || ""}
          </h2>

          <div className="relatorio-form">
            <div className="relatorio-table-container">
              <div className="relatorio-table-header">
                <div>Questão</div>
                <div>Alternativa</div>
                <div className="relatorio-col-span-2">Resultado</div>
                <div className="relatorio-col-span-3">Dificuldade</div>
                <div className="relatorio-col-span-2">Tive <br></br>Dúvida</div>
              </div>

              <div className="relatorio-table-subheader">
                <div></div>
                <div></div>
                <div>Acertei</div>
                <div>Errei</div>
                <div>Fácil</div>
                <div>Média</div>
                <div>Difícil</div>
                <div>Sim</div>
                <div>Não</div>
              </div>

              {questoesOrdenadas.map((questao, index) => {
                const isFirstOfSection = index === 0 || questoesOrdenadas[index - 1].secao !== questao.secao;

                return (
                  <React.Fragment key={index}>
                    {isFirstOfSection && (
                      <div className="relatorio-section-title">
                        {titulosSecoes[questao.secao]}
                      </div>
                    )}

                    <div className="relatorio-table-row">
                      <div className="relatorio-cell relatorio-question-number">
                        {questoesOrdenadas
                          .slice(0, index)
                          .filter(q => q.secao === questao.secao).length + 1}
                      </div>

                      <div className={questao.secao.includes('dis') ? 'relatorio-cell discursiva' : 'relatorio-cell'}>
                        {questao.secao.includes('dis') ? 'Discursiva' : (
                          <div className="relatorio-cell relatorio-alternativas">
                            {['A', 'B', 'C', 'D', 'E'].map((option) => (
                              <label key={option} className="relatorio-radio-label">
                                <input 
                                  type="radio" 
                                  name={`alternativa-${index + 1}`} 
                                  value={option} 
                                  onChange={(e) => handleRespostaChange(index + 1, questao.secao, "resposta", e.target.value)} 
                                />
                                <span className="relatorio-custom-radio">{option}</span>
                              </label>
                            ))}
                          </div>
                        )}
                      </div>

                      <div className="relatorio-cell">
                        <input 
                          type="radio" 
                          name={`resultado-${index + 1}`} 
                          value="1" 
                          onChange={() => handleRespostaChange(index + 1, questao.secao, "acerto", "1")} 
                        />
                      </div>
                      <div className="relatorio-cell">
                        <input 
                          type="radio" 
                          name={`resultado-${index + 1}`} 
                          value="0" 
                          onChange={() => handleRespostaChange(index + 1, questao.secao, "acerto", "0")} 
                        />
                      </div>

                      <div className="relatorio-cell">
                        <input 
                          type="radio" 
                          name={`dificuldade-${index + 1}`} 
                          value="1" 
                          onChange={() => handleRespostaChange(index + 1, questao.secao, "dificuldade", "1")} 
                        />
                      </div>
                      <div className="relatorio-cell">
                        <input 
                          type="radio" 
                          name={`dificuldade-${index + 1}`} 
                          value="2" 
                          onChange={() => handleRespostaChange(index + 1, questao.secao, "dificuldade", "2")} 
                        />
                      </div>
                      <div className="relatorio-cell">
                        <input 
                          type="radio" 
                          name={`dificuldade-${index + 1}`} 
                          value="3" 
                          onChange={() => handleRespostaChange(index + 1, questao.secao, "dificuldade", "3")} 
                        />
                      </div>

                      <div className="relatorio-cell">
                        <input 
                          type="radio" 
                          name={`duvida-${index + 1}`} 
                          value="1" 
                          onChange={() => handleRespostaChange(index + 1, questao.secao, "duvida", "1")} 
                        />
                      </div>
                      <div className="relatorio-cell">
                        <input 
                          type="radio" 
                          name={`duvida-${index + 1}`} 
                          value="0" 
                          onChange={() => handleRespostaChange(index + 1, questao.secao, "duvida", "0")} 
                        />
                      </div>
                    </div>
                  </React.Fragment>
                );
              })}
            </div>
          </div>

          <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
            <button 
              className={`button relatorio ${isSubmitting ? 'disabled' : ''}`}
              onClick={submitRelatorio}
              disabled={isSubmitting}
            > 
              {isSubmitting ? 'Enviando...' : 'Submeter Relatório'}
            </button>

            <button 
              className="button relatorio simplified"
              onClick={async () => {
                const userID = localStorage.getItem('userID');
                const aulaID = selectedRelatorio?.id;
                
                try {
                  // Criptografa o ID do usuário
                  const responseUser = await fetch(`https://rvensino.com.br/get.php?action=criptografar&data=${userID}`);
                  const encryptedUserID = await responseUser.text();
                  
                  // Criptografa o ID da aula
                  const responseAula = await fetch(`https://rvensino.com.br/get.php?action=criptografar&data=${aulaID}`);
                  const encryptedAulaID = await responseAula.text();
                  
                  // Abre a página com os IDs criptografados
                  window.open(`https://rvensino.com.br/relatorio.php?uid=${encryptedUserID}&aid=${encryptedAulaID}`, '_blank');
                } catch (error) {
                  console.error('Erro ao criptografar dados:', error);
                  setMessage("Erro ao preparar envio simplificado. Por favor, tente novamente.");
                }
              }}
              style={{
                backgroundColor: '#f0f0f0',
                color: '#666',
                border: '1px solid #ddd',
                padding: '8px 15px'
              }}
            > 
              Envio Simplificado
            </button>
          </div>

          {message && <p className="relatorio-mensagem">{message}</p>}
        </div>
      </div>
    )}
  </div>
);
}

export default Disciplinas;
